import React from 'react';
import { BasicModal } from "~/shared/ui/modals/BasicModal";
import { Stack } from '@mui/material';
import { Box } from '@mui/material';
import { IModalTemplateCreateCampaignProps } from './types';

export const ModalTemplateCreateCampaign: React.FC<IModalTemplateCreateCampaignProps> = ({
  open,
  handleClose,
  title_button,
  children,
  minWidth,
  handleOpen,
  tootlipText = '',
  disabled = false,
  buttonIcon,
}) => {
  return (
    <Stack display="flex" flexDirection="column" justifyContent="space-between">
      <BasicModal
        title_button={title_button}
        disabled={disabled}
        tootlipText={tootlipText}
        isIcon
        buttonIcon={buttonIcon}
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            minWidth: minWidth,
          }}>
          {children}
        </Box>
      </BasicModal>
    </Stack>
  );
};
